import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/diario/form_cad'


function CadastrarDiarioScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Diário" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarDiarioScreen;